import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './ui/card';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MetricCard = ({ title, value, subtitle, icon: Icon, trend, delay = 0, accentColor = 'primary' }) => {
  const colorClasses = {
    primary: 'text-primary bg-primary/10',
    success: 'text-[hsl(var(--success))] bg-[hsl(var(--success-light))]',
    accent: 'text-[hsl(var(--accent))] bg-[hsl(var(--accent-light))]',
    info: 'text-[hsl(var(--info))] bg-[hsl(var(--info-light))]'
  };

  const colorClass = colorClasses[accentColor] || colorClasses.primary;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      whileHover={{ y: -2, scale: 1.005 }}
      whileTap={{ scale: 0.995 }}
      data-testid={`metric-card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <Card className="border-0 shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden relative group">
        {/* Subtle gradient overlay on hover */}
        <div className="absolute inset-0 bg-gradient-to-br from-white via-white to-muted/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        <CardContent className="p-6 relative z-10">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
              <h3 className="text-3xl font-bold tracking-tight" style={{ fontFamily: 'Fredoka, sans-serif' }}>
                {value}
              </h3>
              {subtitle && (
                <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>
              )}
            </div>
            {Icon && (
              <motion.div
                className="mb-4 relative z-20"
                whileHover={{ scale: 1.05, rotate: 2 }}
                transition={{ type: 'spring', stiffness: 400, damping: 15 }}
              >
                <Icon size={100} className="h-25 w-25" />
              </motion.div>
            )}
          </div>
          
          {trend && (
            <div className={`flex items-center gap-1 text-sm font-medium ${
              trend.direction === 'up' ? 'text-[hsl(var(--success))]' : 'text-[hsl(var(--destructive))]'
            }`}>
              {trend.direction === 'up' ? (
                <TrendingUp className="h-4 w-4" />
              ) : (
                <TrendingDown className="h-4 w-4" />
              )}
              <span>{trend.value}</span>
              <span className="text-muted-foreground font-normal ml-1">{trend.label}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default MetricCard;